import { Chain } from '@ankr.com/chains-list';

import { flatChain } from './flatChain';

export const hasPublicSubchains = (chain: Chain) => {
  return flatChain(chain).some(subchain => subchain.isPublic);
};
